import type { ReactNode } from 'react';
import { strings } from '../strings';
import { Header } from './Header';

export function Layout({ children, tenantLink }: { children: ReactNode; tenantLink?: string }) {
  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main"
        className="sr-only bg-white p-3 focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-10"
      >
        {strings.skipToContent}
      </a>
      <Header tenantLink={tenantLink} />
      <main id="main" tabIndex={-1} className="mx-auto w-full max-w-6xl flex-1 px-4 py-8">
        {children}
      </main>
    </div>
  );
}
